import React, { FC } from 'react';

import IconButton, { BorderRadius } from '../IconButton';

import { AppLayoutContextValue } from './AppLayoutContextProvider.types';
import { useAppLayoutContext } from './hooks';

const SidebarPanelButton: FC = () => {
  const { openContentSidebarAriaLabel, openSidebarPanel } = useAppLayoutContext() as AppLayoutContextValue;

  return (
    <IconButton
      size={32}
      ariaLabel={openContentSidebarAriaLabel}
      iconName="OpenPane"
      backgroundHoverColor="neutralLighter"
      borderRadius={BorderRadius.Soft}
      onClick={openSidebarPanel}
      className="qaSidebarPanelButton"
    />
  );
};

export default SidebarPanelButton;
